/**
 * @fileoverview SearchBar Component
 * @author Lisa Liu (lliu@yext.com)
 */
goog.declareModuleId('yext.ui.components.searchbar');

import {GRAY3} from '/ui/colors/colors';
import {yext} from '/ui/lib/msg';


/**
 * @param {{onSearch: (function(string):void),
 *          placeholder?: string,
 *          searchTerm?: string}} props
 * @returns {React.ReactElement}
 */
export function SearchBar({
  onSearch,
  placeholder,
  searchTerm,
}) {
  const searchActive = searchTerm && searchTerm.length > 0;
  const buttonCssClass = searchActive ? 'clear-search' : 'clear-search search__cleared';

  return (
    <div style={{
      position: 'relative',
      display: 'flex',
      height: '40px',
      marginBottom: '-1px',
    }}>
      <input
        type="text"
        value={searchTerm}
        onChange={e => onSearch(e.target.value)}
        placeholder={placeholder}
        style={{
          boxSizing: 'border-box',
          flex: '1 1',
          height: '100%',
          border: '0',
          borderTop: '1px solid ' + GRAY3,
          borderBottom: '1px solid ' + GRAY3,
          paddingLeft: '15px',
          paddingRight: '25px',
          borderRadius: '0',
          zIndex: '1',
        }}/>
      <button
        type="button"
        tabIndex={searchActive ? 0 : -1}
        className={buttonCssClass}
        onClick={() => onSearch('')}>
        {yext.msg('Clear Search')}
      </button>
    </div>
  );
}
